<template>
  <div class="welcoming-col d-flex flex-column justify-space-between pa-5">
    <div>
      <v-img
        class="d-flex justify-start"
        src="@/assets/logo.png"
        width="120"
      ></v-img>
    </div>
    <slot />
    <div></div>
  </div>
</template>

<script>
export default {
  name: "SAuthSide",
};
</script>

<style scoped>
.welcoming-col {
  background-image: linear-gradient(to top, #00865bd9, #00445ddd),
    url("~@/assets/background-2.png");
  background-size: cover;
  background-position: center;
  height: 100%;
}
</style>
